import angular from "angular";
import htmlTemplate from "./sb_deliverable_notes.html";
import directiveCtrl from "./sb_deliverable_notes.controller";
import "common/dialog/issueEditor/issue_editor.dialog";
import "common/dialog/noteTargetSelection/note_target_selection.dialog";

export default angular
    .module("sbApp.sbDeliverableNotes", [
        "sbApp.directives",
        "sbApp.sbIssueEditorDialog",
        "sbApp.sbNoteTargetSelectionDialog",
        "sbApp.dialog",
    ])
    .directive("sbDeliverableNotes", function () {
        return {
            restrict: "E",
            bindToController: true,
            controllerAs: "notes",
            templateUrl: htmlTemplate,
            scope: {
                deliverable: "<",
                notes: "<",
                highlightedNoteId: "<",
                isLoading: "<",
                onCreateNote: "&",
                onPrint: "&",
                teams: "<",
                selectedTeam: "<",
                onSelectedTeamChange: "&",
            },
            controller: directiveCtrl,
        };
    });
